import React, { useEffect, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import RoutesGuest from "./RoutesGuest/RoutesGuest";
import LoginRedirect from "./middleware/LoginRedirect";
import ProtectedRoute from "./middleware/ProtectedRoute";
import { RoutesAuth } from "./RoutesAuth/RoutesAuth";
import { useAuthStore } from "../zustand/ZustandContext";
import { userAuthentication } from "../services/Auth";
import { LoadingScreen } from "../components/atoms/LoadingScreen/LoadingScreen";

const MainRouter = () => {
    const [loading, setLoading] = useState(true);
    const login = useAuthStore((state) => state.login);
    const logout = useAuthStore((state) => state.logout);

    useEffect(() => {
        // Verificar autenticación al cargar la aplicación
        const checkInitialAuth = async () => {
            try {
                const authData = await userAuthentication();

                // Si hay una sesión válida, restaurar el estado de autenticación
                if (authData.authenticated && authData.accessTokenValid) {
                    login();
                } else {
                }
            } catch (error) {
                console.error(
                    "❌ [MainRouter] Error al verificar autenticación:",
                    error
                );
            } finally {
                setLoading(false);
            }
        };

        checkInitialAuth();

        // Escuchar evento de token expirado desde el interceptor de Axios
        const handleTokenExpired = () => {
            logout();
        };

        window.addEventListener("auth:token-expired", handleTokenExpired);

        return () => {
            window.removeEventListener(
                "auth:token-expired",
                handleTokenExpired
            );
        };
    }, [login, logout]);

    if (loading) {
        return <LoadingScreen title="Verificando sesión..." />;
    }

    return (
        <BrowserRouter>
            <Routes>
                <Route index element={<Navigate to="/login" replace />} />

                <Route element={<LoginRedirect />}>{RoutesGuest()}</Route>
                <Route element={<ProtectedRoute />}>{RoutesAuth()}</Route>
            </Routes>
        </BrowserRouter>
    );
};
export default MainRouter;
